module.exports = __webpack_public_path__ + "img/individual-filled.f3e5d30d.svg";